import 'react-day-picker/dist/style.css';
import { Popover } from '@headlessui/react';
import { DateCalendar } from '@mui/x-date-pickers';
import { type VyDate } from '@vy/utils';
import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  jsDateToPickerValue,
  pickerValueToJsDate,
} from '../../new-design/date-picker/picker-value-utils';
import './DatePicker.css';

export type DatePickerProps = {
  onSelect: (date: Date | undefined) => Promise<void> | void;
  date: Date | null;
  calendarClassName?: string;
  containerClassName?: string;
  buttonContainerClassName?: string;
  children: ReactNode;
};

export default function DatePicker({
  onSelect,
  date = null,
  calendarClassName: externalCalendarClassName,
  containerClassName: externalContainerClassName,
  buttonContainerClassName: externalButtonContainerClassName,
  children,
}: DatePickerProps) {
  const popoverClassName = twMerge('w-[312px]', externalContainerClassName);
  const buttonContainerClassName = twMerge(
    'w-[312px] bg-transparent outline-none',
    externalButtonContainerClassName,
  );

  const handleSelect = useCallback(
    async (close: () => void, newDate: VyDate | null) => {
      await onSelect(pickerValueToJsDate(newDate) ?? undefined);
      close();
    },
    [onSelect],
  );

  return (
    <Popover className={popoverClassName}>
      <Popover.Button className={buttonContainerClassName}>{children}</Popover.Button>
      <Popover.Panel className="border-light-gray absolute z-10 mt-2 rounded-2xl border bg-white shadow-md">
        {({ close }) => (
          <DateCalendar
            value={jsDateToPickerValue(date)}
            className={externalCalendarClassName}
            onChange={(newDate) => handleSelect(close, newDate)}
          />
        )}
      </Popover.Panel>
    </Popover>
  );
}
